import React from 'react';
// context and data
import useTrackPageShown from 'src/viewLayer/components/hooks/useTrackPageShown';
// view components
import EmailInput from 'src/viewLayer/components/shared/Inputs/EmailInput';
import CardLayout from 'src/viewLayer/components/pages/CardLayout';
import BackButton from 'src/viewLayer/components/pages/BackButton';
import SignupLink from 'src/viewLayer/components/shared/HintLinks/SignupLink';
import TrackableButton from 'src/viewLayer/components/shared/TrackableButton';
import HandCardImage from 'src/viewLayer/components/pages/Images/HandCard.svg';
import ScribbleImage from 'src/viewLayer/components/pages/Images/Scribble.svg';
import EmailImage from './Email.svg';
import ZendeskWidget from './ZendeskWidget';
import './index.scss';
import { t } from 'src/viewLayer/helpers/translations';
import { useRouteParamsContext } from 'src/viewLayer/components/contexts/RouteParamsContext';

export default function LoginEmailPage({
    appType,
    path,
    email,
    errorKey,
    isFocused,
    setFocus,
    inProgress,
    onSubmit,
    onChange,
    onReset
  }) {
  useTrackPageShown({ appType,  pageType: path });
  const { queryParamsObj, locale } = useRouteParamsContext();

  // if the user is viewing the page in German and came from a link to cancel
  const userWantsToCancelSubscription = locale === 'de' && queryParamsObj.get('cancel');

  const pageTitleKey = userWantsToCancelSubscription ? 'email.cancel.title' : 'email.title';

  return (
    <div className="LoginEmailPage">
      <CardLayout
        appType={appType}
        title={ t(pageTitleKey) }
        Image={ EmailImage }
        BackgroundItems={ [HandCardImage, ScribbleImage] }
        hideTermsAndConditions={ userWantsToCancelSubscription }
      >
        { !userWantsToCancelSubscription && <SignupLink /> }
        <BackButton trackingId="backbutton-webview-dismiss" path={ path } />
        <form onSubmit={ onSubmit }>
          <EmailInput
            clearValue={ onReset }
            errorKey={ errorKey }
            isFocused={ isFocused }
            setFocus={ setFocus }
            disabled={ inProgress }
            onChangeHandler={ onChange }
            value={ email }
          />
          <div className="actions">
            <TrackableButton
              disabled={ email.length === 0 || inProgress }
              inProgress={ inProgress }
              trackingId="email_continue"
            >
              { t('email.button.continue') }
            </TrackableButton>
          </div>
        </form>
      </CardLayout>
      <ZendeskWidget />
    </div>
  );
};
